export default {
  GET_ECONOMIC_ACTIVITIES_QUERY_SERVICE: Symbol.for('GET_ECONOMIC_ACTIVITIES_SERVICE'),
  ECONOMIC_ACTIVITY_REPOSITORY: Symbol.for('ECONOMIC_ACTIVITY_REPOSITORY'),
  ONBOARDING_CATALOGS_ECONOMIC_ACTIVITY_STATE_MANAGER:
    Symbol.for('ONBOARDING_CATALOGS_ECONOMIC_ACTIVITY_STATE_MANAGER'),
};
